import { useCallback, useState } from 'react';
import { useRouter } from 'next/router';

//* HOC's
import { withUserContext, withUIContext, withLanguageContext } from 'context';

//* Config
import { config } from 'helpers';

//* Components
import Text from 'components/common/Text';
import Container from 'components/common/Container';
import FormContainer from 'components/common/FormContainer';
import FormItem from 'components/common/FormItem';
import FormInput from 'components/common/FormInput';
import Button from 'components/common/Button';

//* Popups
import RegisterPopup from 'components/common/Popups/RegisterPopup';
import ForgotPassword from 'components/common/Popups/ForgotPassword';

//* Style
import LoginPopupStyle from './style';

const LoginPopup = ({ login, openPopup, popupProps, togglePopup, translate }) => {
	//! Router
	const router = useRouter();

	//! States
	const [isSend, setIsSend] = useState(false);

	const onFinish = useCallback((values) => {
		setIsSend('loading');

		return login(values)
			.then(() => {
				togglePopup();

				popupProps.link && (window.location.href = popupProps.link);

				popupProps.isReset && router.push(config.routes.mediaLibrary.path);

				return Promise.resolve();
			})
			.catch((err) => {
				setIsSend(false);

				return Promise.reject(err);
			});
	}, []);

	//! Open forgot password popup
	const handleForgotPassword = useCallback(() => {
		openPopup(<ForgotPassword />);
	}, [openPopup]);

	//! Open register popup
	const handleSignUp = useCallback(() => {
		const link = popupProps.link;
		openPopup(<RegisterPopup />, { link });
	}, [openPopup]);

	return (
		<>
			<LoginPopupStyle />

			<div className='login-popup-content-wrap'>
				<Text
					className={'h4 font-ping-medium login-popup-title'}
					text={'login'}
				/>

				<Text
					className={'pS font-ping-medium login-popup-subtitle'}
					text={'loginSubtitle'}
				/>

				<FormContainer onFinish={onFinish}>
					<Container
						full
						className='login-popup-cont'>
						<FormItem
							name={'email'}
							validationType={'email'}
							className={'form-item'}>
							<FormInput placeholder={`${translate('email')}*`} />
						</FormItem>

						<FormItem
							validationType='password'
							name='password'
							className={'form-item'}>
							<FormInput
								type='password'
								placeholder={`${translate('password')}*`}
							/>
						</FormItem>
					</Container>

					<Container
						full
						className='login-popup-cont'>
						<Text
							className='forgot-password secondaryColor2 underline pXS font-ping-bold'
							text={'forgotPassword'}
							onClick={handleForgotPassword}
						/>

						<div className='lower-buttons-wrap'>
							<Text
								className='pS sign-up colorBigStone underline font-ping-bolder'
								text={'signUp'}
								onClick={handleSignUp}
							/>

							<Button
								text={'login'}
								type={'icon-aside'}
								className={`login-btn`}
								disabled={isSend === 'loading'}
								isBtnLoad={isSend === 'loading'}
							/>
						</div>
					</Container>
				</FormContainer>
			</div>
		</>
	);
};

export default withLanguageContext(withUIContext(withUserContext(LoginPopup, ['login']), ['openPopup', 'popupProps', 'togglePopup']), ['translate']);
